module.exports = __webpack_public_path__ + "img/arrow.25eabf19.svg";